import { gql } from '@apollo/client';

const ITEM_FRAGMENT = gql`
  fragment itemInCompleteBong on Item {
    id
    ageRestricted
    tags
    manualPrice
    manualName
    volumeSuffix
    defaultOrderStatus
    titleLang {
      id
      se
      en
      es
      no
    }
    vatRate
    descriptionLang {
      id
      se
      en
      es
      no
    }
    courseType {
      id
      color
      label
      name
      order
    }
    allergens
    upsales {
      id
      hideInPOS
      name {
        id
        se
        en
        es
        no
      }
      items {
        id
        titleLang {
          id
          se
          en
          es
          no
        }
        defaultPrice
      }
    }

    image {
      id

      file {
        id
        url
      }
    }

    modificationGroups
    allergyTags
    costBasis
    disableMembershipDiscount
  }
`;

export default gql`
  query CompleteBongQuery($id: ID!) {
    venue: Venue(id: $id) {
      id

      company {
        id
        defaultOrderStatus

        categories {
          id
          order
          color

          ukVatRate

          nameLang {
            id
            se
            en
            es
            no
          }
          descriptionLang {
            id
            se
            en
            es
            no
          }

          items(filter: { deleted: false }) {
            ...itemInCompleteBong
          }

          image {
            id
            file {
              id
              url
            }
          }
        }

        items(filter: { deleted: false }) {
          ...itemInCompleteBong
        }

        offers(context: [POS]) {
          id
          enabled
          nameLang {
            id
            se
            en
            es
            no
          }
          image {
            id
            file {
              id
              url
            }
          }
          type
          discountType
          discountRate
          overrideItemPrices

          items(filter: { deleted: false }) {
            id
          }

          categories {
            id
            items(filter: { deleted: false }) {
              id
            }
          }

          stages {
            id
            discountRate
            discountType
            title {
              id
              se
              en
              es
              no
            }
            items(filter: { deleted: false }) {
              id
            }
          }
        }

        layouts {
          id
          name {
            id
            se
            en
            no
            es
          }
          categories {
            id
            name {
              id
              se
              en
              no
              es
            }
            order
            color
            page {
              id
              name {
                id
                se
                en
                no
                es
              }
              rows
              columns
              buttons
            }
          }
        }

        pages {
          id
          name {
            id
            se
            en
            no
            es
          }
          rows
          columns
          buttons
        }

        modificationGroups {
          id
          internalName
          externalName
          type
          required
          expandedByDefault
          preselectedVariations
          isGridViewEnabled
          variations {
            id
            price
            allergen
            name
            nameLang {
              id
              se
              en
              es
              no
            }
          }
        }
      }

      floorPlans {
        id
        name

        tables {
          id
          code
          rotation
          posX
          posY
          deleted

          floorPlan {
            id
          }
        }
      }
    }
  }

  ${ITEM_FRAGMENT}
`;
